import React from "react";
import {
  Box,
  Typography,
  CardMedia,
  Grid,
  Autocomplete,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Paper,
} from "@mui/material";

import QRCode from "react-qr-code";
import rightear from "../../../assets/images/left-ear.png";
import leftear from "../../../assets/images/right-ear.png";
import CustomInput from "../../../components/inputs/CustomInput";
import { DRUM, WAX } from "../../../utils/constants";
import { findObjectKeyByValue, titleCase } from "../../../utils/helper";

const OtoScopeViewUi = ({
  fields,
  setFields,
  fetchFunction,
  isView,
  errors,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        // minHeight: "100vh",
        p: { xs: 1.5, sm: 2, md: 3 },
        background: "#F8FAFC",
        overflow: "auto",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, sm: 3, md: 4 },
              borderRadius: "20px",
              background: "#FFFFFF",
              border: "1px solid #F6D5D5",
              borderTop: "5px solid #D9534F",
              boxShadow: "0 6px 20px rgba(0,0,0,0.04)",
              minHeight: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 4,
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "18px",
                    sm: "22px",
                    md: "18px",
                  },
                  fontWeight: 700,
                  color: "#D9534F",
                }}
              >
                Right Ear
              </Typography>

              <Box
                sx={{
                  p: 3,
                  borderRadius: "20px",
                  background: "#FFF1F1",
                  border: "1px solid #FFD7D7",
                  fontSize: "13px",
                  color: "#D9534F",
                  fontWeight: 600,
                }}
              >
                {fields?.right_ear ? "Evaluated" : "Not Evaluated"}
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mb: 4,
              }}
            >
              <Box
                sx={{
                  border: "8px solid #F8D8D8",
                  borderRadius: "50%",
                  width: {
                    xs: 130,
                    sm: 150,
                    md: 180,
                    lg: 190,
                  },
                  height: {
                    xs: 130,
                    sm: 150,
                    md: 180,
                    lg: 190,
                  },
                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {fields?.right_ear ? (
                  <CardMedia
                    component="img"
                    image={fields.right_ear}
                    alt="Right Ear"
                    sx={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                ) : (
                  <CardMedia
                    component="img"
                    image={rightear}
                    alt="Right Ear"
                    sx={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                )}
              </Box>
            </Box>

            <Box
              sx={{
                width: "100%",
                maxWidth: "420px",
                mx: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Autocomplete
                disableClearable
                disabled={isView}
                value={
                  fields?.right_ear_wax
                    ? findObjectKeyByValue(fields?.right_ear_wax, WAX)
                    : null
                }
                onChange={(e, newVal) => {
                  setFields({
                    ...fields,
                    right_ear_wax: newVal ? newVal._id : null,
                    other_right_wax: "",
                  });
                }}
                options={[
                  ...Object.keys(WAX).map((key) => ({
                    label: titleCase(key),
                    _id: WAX[key],
                  })),
                ]}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    background: "#FAFAFA",
                  },
                }}
                renderInput={(params) => (
                  <CustomInput
                    placeholder="Select Right Wax"
                    {...params}
                    label="Select Right Wax"
                  />
                )}
              />

              {errors?.otherRightWax && (
                <Typography color="error" variant="body2">
                  Other Right Ear Wax is Required *
                </Typography>
              )}

              {fields.right_ear_wax == WAX.OTHER && (
                <CustomInput
                  value={fields.other_right_wax}
                  onChange={(e) =>
                    setFields({
                      ...fields,
                      err: "",
                      other_right_wax: e.target.value,
                    })
                  }
                  disabled={true}
                  type="text"
                  label="Other Right Ear Wax"
                />
              )}

              <Autocomplete
                disableClearable
                disabled={isView}
                value={
                  fields?.right_eardrum
                    ? findObjectKeyByValue(fields?.right_eardrum, DRUM)
                    : null
                }
                onChange={(e, newVal) => {
                  const newEardrum = newVal ? newVal._id : null;
                  setFields({
                    ...fields,
                    right_eardrum: newEardrum,
                    is_discharge_right:
                      newEardrum === DRUM.PERFORATED ? true : null,
                    other_right_drum: "",
                  });
                }}
                options={[
                  ...Object.keys(DRUM).map((key) => ({
                    label: titleCase(key),
                    _id: DRUM[key],
                  })),
                ]}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    background: "#FAFAFA",
                  },
                }}
                renderInput={(params) => (
                  <CustomInput
                    placeholder="Select Right Drum"
                    {...params}
                    label="Select Right Drum"
                  />
                )}
              />
              {fields?.right_eardrum == DRUM.PERFORATED && (
                <Box sx={{ mt: 1 }}>
                  <RadioGroup row>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                      }}
                    >
                      <FormControlLabel
                        disabled={isView}
                        checked={fields?.is_discharge_right == true}
                        onChange={() => {
                          setFields({
                            ...fields,
                            is_discharge_right: true,
                          });
                        }}
                        value={true}
                        control={<Radio />}
                        label={
                          <Typography fontSize="14px">
                            Discharge Active
                          </Typography>
                        }
                      />

                      <FormControlLabel
                        disabled={isView}
                        checked={fields?.is_discharge_right == false}
                        onChange={() => {
                          setFields({
                            ...fields,
                            is_discharge_right: false,
                          });
                        }}
                        value={false}
                        control={<Radio />}
                        label={
                          <Typography fontSize="14px">
                            Discharge Inactive
                          </Typography>
                        }
                      />
                    </Box>
                  </RadioGroup>
                </Box>
              )}

              {errors?.otherRightDrum && (
                <Typography color="error" variant="body2">
                  Other Right Ear Drum is Required *
                </Typography>
              )}

              {fields.right_eardrum == DRUM.OTHER && (
                <CustomInput
                  value={fields.other_right_drum}
                  disabled={true}
                  onChange={(e) =>
                    setFields({
                      ...fields,
                      err: "",
                      other_right_drum: e.target.value,
                    })
                  }
                  type="text"
                  label="Other Right Ear Drum"
                />
              )}
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, sm: 3, md: 4 },
              borderRadius: "20px",
              background: "#FFFFFF",
              border: "1px solid #D9EBF7",
              borderTop: "5px solid #2D9CDB",
              boxShadow: "0 6px 20px rgba(0,0,0,0.04)",
              minHeight: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 4,
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "18px",
                    sm: "22px",
                    md: "18px",
                  },
                  fontWeight: 700,
                  color: "#2D9CDB",
                }}
              >
                Left Ear
              </Typography>

              <Box
                sx={{
                  p: 3,
                  borderRadius: "20px",
                  background: "#EEF8FF",
                  border: "1px solid #D6EEFF",
                  fontSize: "13px",
                  color: "#2D9CDB",
                  fontWeight: 600,
                }}
              >
                {fields?.left_ear ? "Evaluated" : "Not Evaluated"}
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mb: 4,
              }}
            >
              <Box
                sx={{
                  border: "8px solid #D9EEFA",
                  borderRadius: "50%",
                  width: {
                    xs: 130,
                    sm: 150,
                    md: 180,
                    lg: 190,
                  },
                  height: {
                    xs: 130,
                    sm: 150,
                    md: 180,
                    lg: 190,
                  },
                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {fields?.left_ear ? (
                  <CardMedia
                    component="img"
                    image={fields.left_ear}
                    alt="Left Ear"
                    sx={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                ) : (
                  <CardMedia
                    component="img"
                    image={leftear}
                    alt="Left Ear"
                    sx={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                )}
              </Box>
            </Box>

            <Box
              sx={{
                width: "100%",
                maxWidth: "420px",
                mx: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Autocomplete
                disableClearable
                disabled={isView}
                value={
                  fields?.left_ear_wax
                    ? findObjectKeyByValue(fields?.left_ear_wax, WAX)
                    : null
                }
                onChange={(e, newVal) => {
                  setFields({
                    ...fields,
                    left_ear_wax: newVal ? newVal._id : null,
                    other_left_wax: "",
                  });
                }}
                options={[
                  ...Object.keys(WAX).map((key) => ({
                    label: titleCase(key),
                    _id: WAX[key],
                  })),
                ]}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    background: "#FAFAFA",
                  },
                }}
                renderInput={(params) => (
                  <CustomInput
                    placeholder="Select Left Wax"
                    {...params}
                    label="Select Left Wax"
                  />
                )}
              />

              {errors?.otherLeftWax && (
                <Typography color="error" variant="body2">
                  Other Left Ear Wax is Required *
                </Typography>
              )}

              {fields.left_ear_wax == WAX.OTHER && (
                <CustomInput
                  value={fields.other_left_wax}
                  onChange={(e) =>
                    setFields({
                      ...fields,
                      err: "",
                      other_left_wax: e.target.value,
                    })
                  }
                  type="text"
                  disabled={true}
                  label="Other Left Ear Wax"
                />
              )}

              <Autocomplete
                disableClearable
                disabled={isView}
                value={
                  fields?.left_eardrum
                    ? findObjectKeyByValue(fields?.left_eardrum, DRUM)
                    : null
                }
                onChange={(e, newVal) => {
                  const newEardrum = newVal ? newVal._id : null;

                  setFields({
                    ...fields,
                    left_eardrum: newEardrum,
                    is_discharge_left:
                      newEardrum === DRUM.PERFORATED ? true : null,
                    other_left_drum: "",
                  });
                }}
                options={[
                  ...Object.keys(DRUM).map((key) => ({
                    label: titleCase(key),
                    _id: DRUM[key],
                  })),
                ]}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    background: "#FAFAFA",
                  },
                }}
                renderInput={(params) => (
                  <CustomInput
                    placeholder="Select Left Drum"
                    {...params}
                    label="Select Left Drum"
                  />
                )}
              />
              {errors?.otherLeftDrum && (
                <Typography color="error" variant="body2">
                  Other Left Ear Drum is Required *
                </Typography>
              )}

              {fields?.left_eardrum == DRUM.PERFORATED && (
                <Box sx={{ mt: 1 }}>
                  <RadioGroup row>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                      }}
                    >
                      <FormControlLabel
                        disabled={isView}
                        checked={fields?.is_discharge_left === true}
                        onChange={() => {
                          setFields({
                            ...fields,
                            is_discharge_left: true,
                          });
                        }}
                        value={true}
                        control={<Radio />}
                        label={
                          <Typography fontSize="14px">
                            Discharge Active
                          </Typography>
                        }
                      />

                      <FormControlLabel
                        disabled={isView}
                        checked={fields?.is_discharge_left === false}
                        onChange={() => {
                          setFields({
                            ...fields,
                            is_discharge_left: false,
                          });
                        }}
                        value={false}
                        control={<Radio />}
                        label={
                          <Typography fontSize="14px">
                            Discharge Inactive
                          </Typography>
                        }
                      />
                    </Box>
                  </RadioGroup>
                </Box>
              )}

              {fields.left_eardrum == DRUM.OTHER && (
                <CustomInput
                  value={fields.other_left_drum}
                  onChange={(e) =>
                    setFields({
                      ...fields,
                      err: "",
                      other_left_drum: e.target.value,
                    })
                  }
                  type="text"
                  disabled={true}
                  label="Other Left Ear Drum"
                />
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OtoScopeViewUi;